import { useNavigate } from 'react-router-dom';
import { WholesalerCard } from '@molecules/WholesalerCard';
import { SectionTitle } from '@atoms/SectionTitle';
import { useAuthStore } from '@store/authStore';
import type { User } from '@/types';

interface TopWholesalersGridProps {
  wholesalers: User[];
}

export function TopWholesalersGrid({ wholesalers }: TopWholesalersGridProps) {
  const navigate = useNavigate();
  const { isAuthenticated, user } = useAuthStore();
  if (!wholesalers.length) return null;

  const goToWholesaler = (id: string) => {
    const target = `/restaurant?tab=browse&wholesaler=${id}`;
    if (isAuthenticated && user?.role === 'restaurant') {
      navigate(target);
      return;
    }
    navigate(`/login?redirect=${encodeURIComponent(target)}`);
  };

  return (
    <section id="wholesalers" className="bg-white py-16 md:py-20">
      <div className="section-container scroll-mt-24">
        <SectionTitle
          title="Öne Çıkan "
          accent="Toptancılar"
          subtitle="Bölgenizdeki güvenilir toptan gıda tedarikçileri."
        />
        <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
          {wholesalers.map((w, idx) => (
            <WholesalerCard
              key={w.id}
              wholesaler={w}
              rank={idx + 1}
              variant="featured"
              onClick={() => goToWholesaler(w.id)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
